import xss from "xss";

export function GetQueryString(name) {
  let qeryString = decodeURIComponent(
    (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
      window.location.href
    ) || [null, ""])[1].replace(/\+/g, "%20")
  );
  let clean = qeryString;
  clean = clean.replace(new RegExp("javascript:.*"), "");
  clean = xss(clean);
  return clean || null;
}
//替换指定传入参数的值,paramName为参数,replaceWith为新值
export function replaceParamVal(oUrl, paramName, replaceWith) {
  // var oUrl = this.location.href.toString();
  var re = new RegExp("[^?&]?" + paramName + "=[^=&#]*");
  var nUrl = "";
  if (re.exec(oUrl)) {
    nUrl = oUrl.replace(re, paramName + "=" + replaceWith);
  } else {
    if (new RegExp("#/.*\\?.+=.*").exec(oUrl)) {
      nUrl = `${oUrl}&${paramName}=${replaceWith}`;
    } else {
      nUrl = `${oUrl}?${paramName}=${replaceWith}`;
    }
  }
  return nUrl;
}
export default {
  GetQueryString: GetQueryString,
  replaceParamVal: replaceParamVal,
};
